// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-slide-img[data-v-2dfbde12] {\n  height: 225px;\n  width: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.carousel-control-prev-icon[data-v-2dfbde12],\n.carousel-control-next-icon[data-v-2dfbde12] {\n  color: blue;\n}\n", ""]);
// Exports
module.exports = exports;
